import { EnumRichiestaDTOStato, RichiestaDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { DividerTitleElement } from '@framework/ui';
import { Empty } from 'antd';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { IntegrationRow } from './IntegrationRow';

interface IIntegrationRowsProps {
  submissionId?: string | null;
  integrations: RichiestaDTO[] | undefined;
}

/**
 * Componente per le righe delle integrazioni da mostrare in tabella.
 * Sia per le richieste attive che per quelle precedenti.
 */
export function IntegrationRows(props: IIntegrationRowsProps) {
  const { integrations, submissionId } = props;
  const { t } = useTranslation();
  const sortedIntegrations = useMemo(() => {
    const sorted = [...(integrations ?? [])];
    sorted.sort((a, b) => {
      return dayjs(a.dataInvio).isBefore(dayjs(b.dataInvio)) ? 1 : -1;
    });

    return sorted;
  }, [integrations]);

  const current = sortedIntegrations?.filter(
    i =>
      i.stato === EnumRichiestaDTOStato.INVIATA ||
      i.stato === EnumRichiestaDTOStato.RICEVUTA ||
      i.stato === EnumRichiestaDTOStato.CONCLUSA ||
      i.stato === EnumRichiestaDTOStato.BOZZA,
  );

  const previous = sortedIntegrations?.filter(
    i => i.stato === EnumRichiestaDTOStato.INTEGRATA,
  );

  const previousRows =
    previous && previous.length > 0 ? (
      previous?.map(integration => (
        <IntegrationRow
          key={integration.id}
          submission={integration}
          isCurrent={integration.id == submissionId}
        />
      ))
    ) : (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t(
          'integration-rows.nessuna-richiesta-precedente',
          'Nessuna richiesta precedente',
        )}
      />
    );

  const currentRows =
    current && current.length > 0 ? (
      current?.map(integration => (
        <IntegrationRow
          key={integration.id}
          isCurrent={integration.id == submissionId}
          submission={integration}
        />
      ))
    ) : (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t(
          'integration-rows.nessuna-richiesta-attiva',
          'Nessuna richiesta attiva',
        )}
      />
    );

  return (
    <>
      <div>
        <DividerTitleElement
          removeTopMargin
          title={t(
            'integration-rows.ultima-integrazione-della-richiesta',
            'Ultima integrazione della richiesta',
          )}
        />
        {currentRows}
      </div>
      <div>
        <DividerTitleElement
          title={t(
            'integration-rows.richieste-integrate',
            'Richieste Integrate (elenco richieste precedenti)',
          )}
        />
        {previousRows}
      </div>
    </>
  );
}
